import { createContext, use, useMemo } from 'react'

const InitializationContext = createContext(null)

export function InitializationProvider({ user, siteKey, children }) {
  const value = useMemo(() => ({ user, siteKey }), [user, siteKey])
  return <InitializationContext value={value}>{children}</InitializationContext>
}

export function useInitialization() {
  return use(InitializationContext)
}
